import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { getNutriDoctors } from "../nutrisalud/NutriDoctorSelect";
import { getQaConfiguration } from "../utils/saludV2Client";

export default function AnticonDoctorSelect({ value, onChange, disabled }) {
  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const enabled = getQaConfiguration().enabled;
  useEffect(() => {
    let cancelled = false;
    if (!enabled) return undefined;
    setLoading(true);
    getNutriDoctors().then(rows => { if (!cancelled) { setOptions(rows); setError(""); } })
      .catch(() => { if (!cancelled) setError("No se pudo cargar el catálogo de profesionales."); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [enabled]);
  const selected = options.find(option => String(option.id) === String(value?.id)) || value;
  const available = selected && !options.some(option => String(option.id) === String(selected.id)) ? [selected, ...options] : options;
  return <Autocomplete fullWidth options={available} value={selected || null} disabled={disabled} loading={loading}
    clearText="Limpiar médico"
    isOptionEqualToValue={(option, current) => String(option.id) === String(current.id)}
    getOptionLabel={option => option.nombreCompleto
      ? `${option.nombreCompleto}${option.profesion ? " · " + option.profesion : ""}` : `ID ${option.id}`}
    onChange={(_, next) => onChange(next)}
    renderInput={params => <TextField {...params} label="Médico responsable" helperText={error || (selected ? `ID ${selected.id}` : "")} />} />;
}
